export default __webpack_public_path__ + "static/anuMehta2-6feb6fd2d41987a02c33e5c1b78cc714.jpg";